import { HistoricalService } from './../../../providers/historical.service';
import {
  Historical
} from './../../historical/historical';
import {
  RealTimeService
} from './../../../providers/real-time.service';
import {
  NavController
} from 'ionic-angular';
import {
  Component,
  ViewChild,
  OnInit,
  ElementRef
} from '@angular/core';
import {
  NavParams
} from 'ionic-angular/navigation/nav-params';
import {
  GlobalService
} from '../../../providers/global.config';
import {
  GeocodingService
} from '../../../utils/geocoding.service';
import {
  DataManagementService
} from '../../../providers/data-management.service';
import {
  RealTimeRecord,
  Vehicule
} from '../../../objects/real-time';
import {
  ToastController,
  ModalController,
  ViewController,
  AlertController,
  Platform
} from 'ionic-angular';
import {
  Subscription
} from "rxjs";
import {
  DatePipe,
  DecimalPipe
} from '@angular/common';
import * as L from 'leaflet';
import Polygon = L.Polygon;
import Marker = L.Marker;
import Icon = L.Icon;
import 'leaflet';
import {
  BehaviorSubject
} from 'rxjs/BehaviorSubject';
import {
  Content
} from 'ionic-angular';

@Component({
  selector: 'page-group-realtime',
  templateUrl: 'group-realtime.html',
})

export class GroupeRealtime {
  @ViewChild('mainScreen') elementView: ElementRef;
  viewHeight: number;
  @ViewChild(Content)
  content: Content;
  group: any;
  page: number = 0;
  vehiculeLoaded: any[];
  vehicules: Array < any > ;
  allGroups: Subscription;
  groups: any[];
  imageUri: string = "../../assets/icons/c1x0.png";
  newRealTimeRecords: RealTimeRecord[] = null;
  oldRealTimeRecords: RealTimeRecord[] = null;
  angles: Map < number, number > = new Map();
  status: boolean = true;
  size: number = 10;
  totalpage: number;
  data:any;
  AllPaths:any;
  mileages:any;
  totalMileage:any;
  imagescar = this.globalService.getimagescar();
  constructor(plateform: Platform, public navCtrl: NavController,private historicalService:HistoricalService,
   private pipe: DecimalPipe, private geocodingService: GeocodingService, public navParams: NavParams,
    private viewCtrl: ViewController, private dataManagementService: DataManagementService, 
    private realTimeService: RealTimeService, private globalService : GlobalService) {
    plateform.ready().then((data) => {
      this.size = Math.floor((plateform.height() - 48) / 48) + 1;
      console.log(this.size +'  '+this.page)
    });
  }


  ngOnInit() {
    this.group = this.navParams.get('group');
  }

  closeModal() {
    this.viewCtrl.dismiss(null);
  }

  ngAfterViewInit() {

    this.realTimeService.findVehiculesByGroupsId(this.group.idGroupe, this.size, this.page).subscribe(x => {
      if (x.last) {
        this.status = false;
      }
      this.vehicules = x.content;
      this.data=x.content;
      this.vehicules.forEach(vehicule => {
        vehicule.realTimeRecord = new RealTimeRecord();
        
        let startHour=new Date().setHours(0,0,0,0);//.//setHours(0,0,0,0).getTime();
        let endDate=new Date().getTime();
        
        this.realTimeService.getRealTimeRecord(vehicule.device.idDevice).subscribe(y => {
          vehicule.realTimeRecord = y;
          vehicule.realTimeRecord.vehicule = new RealTimeRecord();
          vehicule.realTimeRecord.vehicule = vehicule;

          this.AllPaths = this.historicalService.getAllMileages(vehicule.device.idDevice, {startDate: startHour, endDate: endDate }).subscribe(mileages => {
            this.mileages = mileages;
            this.mileages.forEach(mileage => {
              let startHour: any = mileage.startHour;
              mileage.startHour = startHour + (60 * 60 * 1000);
            });
            this.totalMileage = this.mileages[this.mileages.length - 1];
            this.mileages.splice(this.mileages.length - 1);
            vehicule.realTimeRecord.mileages=Math.round(this.totalMileage.drivingDistance);
          }, (err) => {});

          this.trackRealTimeRecord(vehicule.realTimeRecord);
          this.totalpage = x.totalPages;
          

        }, (err) => {
          vehicule.realTimeRecord==null;
          this.trackRealTimeRecord(vehicule.realTimeRecord)
        });
      });

    })
    
    this.data=this.vehicules;
    
    //this.content.addScrollPadding(1); //.subscribe(($event: any) => {});
    // this.content.ionScroll.subscribe(($event: any) => {
    //   this.status = true;
    //   let dimensions = this.content.getContentDimensions();
    //   let scrollHeight = dimensions.scrollHeight;
    //   let scrollTop = dimensions.scrollTop;
    //   let contentHeight = dimensions.contentHeight;
    //   let heightAndScrollTop = contentHeight + scrollTop;
    //   // console.log(scrollHeight +' '+ heightAndScrollTop+' '+heightAndScrollTop);
    //   if ((scrollHeight - heightAndScrollTop) <= 0 && (scrollHeight - heightAndScrollTop) >= 0 && this.totalpage>this.page) {

    //     this.page++;
    //     this.realTimeService.findVehiculesByGroupsId(this.group.idGroupe, this.size, this.page).subscribe(x => {

    //       if (x.content.length > 0) {
    //         if (x.content.length < this.size)
    //           this.status = false;
    //         this.vehiculeLoaded = x.content;
    //         this.vehiculeLoaded.forEach(vehicule => {
    //           vehicule.realTimeRecord = new RealTimeRecord();
    //           this.realTimeService.getRealTimeRecord(vehicule.device.idDevice).subscribe(y => {
    //             vehicule.realTimeRecord = y;
    //             vehicule.realTimeRecord.vehicule = new RealTimeRecord();
    //             vehicule.realTimeRecord.vehicule = vehicule;
    //             this.trackRealTimeRecord(vehicule.realTimeRecord);
    //           }, (err) => {

    //           });
    //         })
    //         this.vehiculeLoaded.forEach(vehicule => {
    //           this.vehicules.push(vehicule);
    //         });
    //         this.status = false;
    //       } else {
    //         this.status = false;
    //       }
    //     })
    //   }else{
    //     this.status=false;
    //   }
    // });


  }
  charger() {
    if (this.totalpage > this.page) {
      this.page++;


      this.realTimeService.findVehiculesByGroupsId(this.group.idGroupe, this.size, this.page).subscribe(x => {
        if (x.last) this.status = false;
       

        this.vehiculeLoaded = x.content;
        this.vehiculeLoaded.forEach(vehicule => {
          vehicule.realTimeRecord = new RealTimeRecord();
          this.realTimeService.getRealTimeRecord(vehicule.device.idDevice).subscribe(y => {
            vehicule.realTimeRecord = y;
            
            vehicule.realTimeRecord.vehicule = new RealTimeRecord();
            vehicule.realTimeRecord.vehicule = vehicule;
            this.trackRealTimeRecord(vehicule.realTimeRecord);
          }, (err) => {
            vehicule.realTimeRecord==null;
           this.trackRealTimeRecord(vehicule.realTimeRecord)
          });
        })
        this.vehiculeLoaded.forEach(vehicule => {
          this.vehicules.push(vehicule);
          this.data.push(vehicule);
        });
        

      })
    }
  

  }

  getItems(ev: any) {
    // Reset items back to all of the items
    // set val to the value of the searchbar
    this.vehicules=this.data;
    let val = ev.target.value;
    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.vehicules = this.vehicules.filter((vehicule) => {
        return (vehicule.matricule.toLowerCase().indexOf(val.toLowerCase()) > -1);
      })
    }
  }
  isValidPoint(point: {
    lat: number,
    lng: number
  }) {
    if (point && point.lng !== 0 && point.lng !== 0) return true;
    else return false;
  }

  goToRealTimeRecord(vehicule: Vehicule, isvalid: boolean) {
    if (isvalid) {

      let data = {
        vehicule: vehicule
      }
      this.viewCtrl.dismiss(data)
    }
  }
  // loadGroups() {
  //   this.allGroups = this.realTimeService.getAllGroups(this.searchWord).subscribe(groupes => {
  //     this.groups = groupes;

  //     this.groups.forEach(group => {
  //       group.vehicules.forEach(vehicule => {
  //         vehicule.realTimeRecord=new RealTimeRecord();
  //         this.realTimeService.getRealTimeRecord(vehicule.idDevice).subscribe(x=>{

  //           vehicule.realTimeRecord = x;
  //           vehicule.realTimeRecord.vehicule=new RealTimeRecord();
  //           vehicule.realTimeRecord.vehicule=vehicule;
  //           this.trackRealTimeRecord(vehicule.realTimeRecord);
  //         },(err) => {

  //         });

  //       })
  //     });
  //   });
  //   //this.getAllRealTimeRecords();
  // }
  // getAllRealTimeRecords() {
  //   this.allRealTimeRecords = this.realTimeService.getAllRealTimeRecords().subscribe(realTimeRecords => {
  //     this.realTimeRecordsItemSource.next(realTimeRecords);
  //     if (this.newRealTimeRecords) {
  //       this.oldRealTimeRecords = this.newRealTimeRecords;
  //     }
  //     this.newRealTimeRecords = realTimeRecords;
  //     realTimeRecords.forEach(realTimeRecord => {
  //       console.log(realTimeRecord)
  //       realTimeRecord.vehicule = this.getVehicule(realTimeRecord.idRealTimeRecord);

  //        this.trackRealTimeRecord(realTimeRecord);
  //       });
  //     });
  //   }
  // getVehicule(idDevice: number): Vehicule {
  //   let foundVehicule = new Vehicule();
  //   for (let i = 0; i < this.groups.length; i++) {
  //     for (let j = 0; j < this.groups[i].vehicules.length; j++) {
  //       if (this.groups[i].vehicules[j].idDevice == idDevice) {
  //         foundVehicule = this.groups[i].vehicules[j];
  //         break;
  //       }
  //     }
  //   }
  //   return foundVehicule;
  // }

  trackRealTimeRecord(realTimeRecord: RealTimeRecord) {
    let angle = 0;
    var date = new Date(realTimeRecord.recordTime);
    realTimeRecord.recordTime = new Date(new Date(realTimeRecord.recordTime).setHours(new Date(realTimeRecord.recordTime).getHours() - 1));
    var minutes = date.getMinutes() + "";
    if (minutes.length == 1) {
      minutes = "0" + date.getMinutes();
    }
    let icon;
    let marker;
    let popup;
    if (!this.dataManagementService.pointInterests) {
      this.dataManagementService.getAllPointInterests().subscribe(pointInterests => {
        this.dataManagementService.pointInterests = pointInterests;
        realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
      })
    } else {
      realTimeRecord.relativePosition = this.dataManagementService.getRelativePosition(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng);
    }
    if (realTimeRecord.type === "AA") {
      angle = realTimeRecord.rotationAngle * 8;
    }
    if (this.oldRealTimeRecords && realTimeRecord.type === "GPRMC") {
      let oldRealTimeRecord = this.getOldRealTimeRecord(realTimeRecord.idRealTimeRecord);
      if (oldRealTimeRecord) {
        if (!this.compareTwoCoordinate(oldRealTimeRecord.coordinate, realTimeRecord.coordinate)) {
          angle = Math.atan2(realTimeRecord.coordinate.lng - oldRealTimeRecord.coordinate.lng, realTimeRecord.coordinate.lat - oldRealTimeRecord.coordinate.lat) * 180 / Math.PI;
          this.angles.set(realTimeRecord.idRealTimeRecord, angle);
        } else {
          angle = this.angles.get(realTimeRecord.idRealTimeRecord);
        }
      }
    }
  
    /* popup = '<b>Chauffeur:</b> ' + this.dataManagementService.getDriverName(realTimeRecord.vehicule.driver) +
          '<br><b>Matricule:</b> ' + realTimeRecord.vehicule.matricule +
          '<br><b>Mark:</b> ' + realTimeRecord.vehicule.mark +
          '<br><b>Lat,Lng:</b><i> [' + this.PipeLngLat(realTimeRecord.coordinate.lat) + ',' + this.PipeLngLat(realTimeRecord.coordinate.lng) + ']</i><br><b>Vitesse :</b>' + realTimeRecord.speed +
          "<br><b>date et l'heure:</b> " + (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + minutes +
          "<br><b>Signal GSM:</b> " + realTimeRecord.signal +
          " <i class='fa fa-wifi' aria-hidden='true'></i><br><b>Sat en vue:</b> " + realTimeRecord.satInView + " <i class='fa fa-globe' aria-hidden='true'></i>";
         
      */
    marker = new Marker(realTimeRecord.coordinate, {
     // rotationAngle: angle
    });

    //this.imageUri:string = "/images/c1x0.png";
    this.imageUri = this.imagescar + "c3x0.png";
    
    realTimeRecord.icon=this.imageUri;
    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition == true) {
      icon = new Icon({
        iconUrl: this.imagescar  + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -10]
      });
      this.imageUri = this.imagescar  + "c4x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed > 0) {
      icon = new Icon({
        iconUrl: this.imagescar  + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      });
      this.imageUri = this.imagescar  + "c1x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'VALID' && realTimeRecord.speed == 0 && realTimeRecord.ignition == false) {
      icon = new Icon({
        iconUrl: this.imagescar  + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      });
      this.imageUri = this.imagescar  + "c2x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord.realTimeRecordStatus == 'NON_VALID' || realTimeRecord.realTimeRecordStatus == 'TECHNICAL_ISSUE') {
      icon = new Icon({
        iconUrl: this.imagescar  + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      });
      this.imageUri = this.imagescar  + "c3x" + Math.abs(Math.round(angle / 45) * 45) + ".png";
    }
    if (realTimeRecord==null) {
      icon = new Icon({
        iconUrl: this.imagescar  + "c3x0.png",
        iconAnchor: [-2, 30],
        popupAnchor: [10, -25]
      });
      this.imageUri = this.imagescar  + "c3x0.png";
    }
    realTimeRecord.icon = this.imageUri;
    
    this.geocodingService.inverseGeoconding(realTimeRecord.coordinate.lat, realTimeRecord.coordinate.lng, 18).subscribe(adress => {
      realTimeRecord.geocoding = this.getGeocoding(adress.address);
      realTimeRecord.geocodingDetails = adress.display_name;
      this.updateSpecificGroups(realTimeRecord);
    }, (err) => {});
  }

  getOldRealTimeRecord(id: number): RealTimeRecord {
    let result = this.oldRealTimeRecords.filter(rt => {
      return rt.idRealTimeRecord == id;
    });
    if (result) return result[0];
    else return null;
  }

  compareTwoCoordinate(p1, p2) {
    if (p1.lat == p2.lat && p1.lng == p2.lng) return true;
    else false;
  }

  PipeLngLat(value: any) {
    return this.pipe.transform(value, '2.2-6');
  }

  getGeocoding(address: any): string {
    let geocoding: string = null;
    if (address) {
      if (address.road != null) {
        geocoding = address.road;
      }
      if (address.neighbourhood != null) {
        geocoding = geocoding ? geocoding + ' ' + address.neighbourhood : address.neighbourhood;
      }
      if (address.city != null) {
        geocoding = geocoding ? geocoding + ' (' + address.city + ')' : address.city;
      }
      if (geocoding == null) {
        geocoding = 'chargement..';
      }
    }
    return geocoding;
  }

  updateSpecificGroups(realTimeRecord: RealTimeRecord) {
    if (this.groups)
      this.groups.forEach(group => {
        if (group)
          group.vehicules.forEach(vehicule => {
            if (vehicule.idDevice == realTimeRecord.idRealTimeRecord)
              vehicule.realTimeRecord = realTimeRecord;
          })
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/groups-page/group-realtime/group-realtime.ts